module.exports = __webpack_public_path__ + "img/announcement-icon.43e93fd3.png";